import {
  EXPORT_CONTENTFUL_STARTED,
  EXPORT_CONTENTFUL_SUCCEEDED,
  EXPORT_CONTENTFUL_FAILED,
} from '../action-types/exportContentfulActionTypes';

const initialState = {
  err: null,
  loading: false,
  contentfulData: [],
};

const exportContentfulReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXPORT_CONTENTFUL_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case EXPORT_CONTENTFUL_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        contentfulData: action.contentfulData,
      };
    }
    case EXPORT_CONTENTFUL_FAILED: {
      return {
        ...state,
        loading: false,
        err: action.err,
      };
    }
    default: {
      return state;
    }
  }
};

export default exportContentfulReducer;
